import React, { Component } from 'react'
import Fade from 'react-reveal/Fade';
import './Input.css'

class Input extends Component {
    makeField(shouldValidate) {
        if (!shouldValidate) {
            return
        }
        const
            value = this.props.value || '',
            invalid = this.props.invalid,
            className = this.props.className + ' form-control' + (invalid ? ' is-invalid' : ''),
            labelClass = this.props.value != '' ? "floatLabelWhenValue" : ''
        return (
            <div className={[`col-md-${this.props.col} mb-3`, 'small-input'].join(' ')}>
                <div className="floatLabel">
                    {/* // <div className="floatLabel"> */}
                    {this.props.elementConfig.type !== 'textarea' ?
                        <div>
                            <input
                                className={className}
                                data-id={this.props.key}
                                placeholder={this.props.float === 'no' ? this.props.elementConfig.placeholder : ''}
                                value={value}
                                onChange={this.props.changed}
                                readOnly={this.props.elementConfig.readOnly == true ? true : false}
                                type={this.props.elementConfig.type}
                            />
                            {this.props.elementConfig.unit !== '' ? <div className="Unit" htmlFor={this.props.key}>
                                {this.props.elementConfig.unit}
                            </div>
                                : ''}
                        </div>
                        : <textarea
                            className={className}
                            data-id={this.props.key}
                            placeholder={this.props.float === 'no' ? this.props.elementConfig.placeholder : ''}
                            readOnly={this.props.elementConfig.readOnly == true ? true : false}
                            value={value}
                            onChange={this.props.changed}
                            type={this.props.elementConfig.type}
                        />}

                    {this.props.float !== 'no' ?
                        <label htmlFor={this.props.key} className={labelClass}>
                            {this.props.elementConfig.placeholder}
                        </label>
                        : ''}
                    <Fade bottom collapse when={invalid}>
                        <div className="invalidFeedback"
                            style={{ display: 'block' }}
                        >
                            {this.props.errorMessage}
                        </div>
                    </Fade>
                </div>
            </div>
        )
    }
    render() {
        const id = this.props.key
        const col = this.props.col
        const inputName = this.props.inputName
        const shouldValidate = this.props.shouldValidate
        return (
            this.makeField({ shouldValidate })
        )
    }
}
export default Input